// reccarousal
const Saint_Gobain="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/placement/company_logo/SG_N.webp"
const first ="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/placement/company_logo/first_resized_N.webp"
const spic="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/placement/company_logo/spic_resize_n.webp"
const delphi_tvs="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/placement/company_logo/TVS_LOGO_.webp"
const zoho="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Homepage_pics/zoho.webp"


// const zoho="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/about/home/zoho.webp"
const lt="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/about/home/lt.webp"



// const gofrugal="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/about/home/gofrugal.webp"
const whiteblue="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/about/home/whiteblue.webp"
export const reccarousal=[
  first,
  Saint_Gobain,
  spic,
  delphi_tvs,
  zoho,
  // hcl,
  lt,
  
  // wipro,
  // whiteblue
]
/**
 * const spic="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/placement/company_logo/spic.webp"
 * const first ="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/placement/company_logo/first.webp"
 * const Saint_Gobain="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/placement/company_logo/Saint-Gobain-Logo.wine.webp"
 */